import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col items-center gap-10 md:flex-row md:gap-20',
    image:
      'h-[350px] w-[350px] rounded-full object-cover md:h-[500px] md:w-[500px]',
    content: 'heading-m'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
